import styled from "styled-components";
import { Colors } from "@/theme";
import { ButtonRegular } from "../ui/buttons";
import { mobile } from "@/theme/common";

interface AcquisitionProps {
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
  handleRedirectToGame: () => void;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background-color: rgba(255, 255, 255, 0.63);
  padding: 24px;
  border-radius: 12px;
  margin-bottom: 18px;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: ${Colors.black};
  text-align: center;
  margin-bottom: 12px;
`;

const Description = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: ${Colors.black};
  margin-bottom: 24px;
  text-align: center;
  font-family: ${({ theme }) => theme.Fonts.ttNormsProNormal};
`;

const Button = styled(ButtonRegular)`
  background-color: ${Colors.black};
  color: ${Colors.white};
  width: 320px;
  border-radius: 12px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  gap: 24px;
  position: relative;
  ${mobile(`
    flex-direction: column;
    gap: 12px;
  `)}
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  align-items: bottom;
  justify-content: center;
  width: 100%;
`;

const Line = styled.div`
  width: 1px;
  height: 80px;
  margin-top: 18px;
  margin-bottom: 18px;
  opacity: 0.8;
  background-color: ${Colors.black};
  ${mobile(`
    display: none;
  `)}
`;

export const Acquisition = ({
  title,
  description,
  buttonText,
  buttonLink,
  handleRedirectToGame,
}: AcquisitionProps) => {
  const handleRedirectToAcquisition = () => {
    window.open(buttonLink, "_blank");
  };

  return (
    <Container>
      <Title>{title}</Title>
      <Row>
        <Col>
          <Description dangerouslySetInnerHTML={{ __html: description }} />
          <Button
            text={buttonText}
            onClick={handleRedirectToAcquisition}
          />
        </Col>
        <Col>
          <Line />
        </Col>
        <Col>
          <Description>Already have an account?</Description>
          <Button
            text={"Sign in and play!"}
            onClick={handleRedirectToGame}
            thickBorder="rgba(0, 0, 0, 0.2)"
          />
        </Col>
      </Row>
    </Container>
  );
};
